<template>
    <div class="tutorial-edit-container">
        <div class="tutorial-edit-content">
            <div class="header-section">
                <el-button type="text" @click="$router.push('/user/upload_tutorial')">
                    <i class="el-icon-arrow-left"></i> 返回教程列表
                </el-button>
            </div>

            <el-card class="box-card" style="border-radius:10px;" shadow="never">
                <div slot="header" class="card-header">
                    <span>{{ isEdit ? '编辑教程' : '新建教程' }}</span>
                </div>

                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="教程标题" required>
                        <el-input v-model="form.title" placeholder="请输入教程标题" maxlength="100" show-word-limit />
                    </el-form-item>

                    <el-form-item label="教程标签" required>
                        <el-select v-model="form.tags" multiple placeholder="选择标签" @focus="loadTypes"
                            style="width:100%;">
                            <el-option v-for="item in tagOptions" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>

                    <el-form-item label="公开状态">
                        <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="公开"
                            inactive-text="私密">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="教程描述">
                        <el-input v-model="form.description" type="textarea" :rows="4" placeholder="请描述教程内容（可选）"
                            maxlength="500" show-word-limit />
                    </el-form-item>

                    <el-form-item label="内容类型" required>
                        <div style="display:flex;background:#c0c4cc;border-radius:18px;width:fit-content;">
                            <div class="no-select"
                                style="padding:0px 20px;border-radius:18px;font-weight:600;font-size:13px;cursor:pointer;"
                                :style="mode === 'video' ? 'background:#484add;color:#fff' : 'background:#c0c4cc;color:#444'"
                                @click="switchMode('video')">视频教程</div>
                            <div class="no-select"
                                style="padding:0px 20px;border-radius:18px;font-weight:600;font-size:13px;cursor:pointer;"
                                :style="mode === 'images' ? 'background:#484add;color:#fff' : 'background:#c0c4cc;color:#444'"
                                @click="switchMode('images')">图文教程</div>
                        </div>
                    </el-form-item>

                    <el-form-item label="教程封面">
                        <div v-if="coverUrl" style="margin-bottom:10px;">
                            <el-image :src="coverUrl" fit="cover"
                                style="width:200px;height:120px;border-radius:8px;border:1px solid #eee;"></el-image>
                            <div style="margin-top:5px;font-size:13px;color:#666;">
                                <i class="el-icon-picture"></i> 当前封面
                                <el-button type="text" size="mini" style="margin-left:10px;"
                                    @click="coverUrl = ''; $nextTick(() => $refs.cosupload_cover && $refs.cosupload_cover.clear_url())">
                                    替换封面
                                </el-button>
                            </div>
                        </div>
                        <div v-if="!coverUrl">
                            <cosupload ref="cosupload_cover" :image_mode="true" upload_class="tutorial" :limit_url="1"
                                :mb="5" :uploadkey="uploadkey" @upload-success="handleCoverSuccess" />
                        </div>
                    </el-form-item>

                    <el-form-item label="教程视频" v-if="mode === 'video'">
                        <!-- 已有视频预览（编辑模式） -->
                        <div v-if="localVideoUrl && !showUpload" style="margin-bottom:10px;">
                            <video :src="localVideoUrl" controls
                                style="width:100%;max-height:300px;border-radius:8px;background:#000;"></video>
                            <div style="margin-top:5px;font-size:13px;color:#666;display:flex;align-items:center;">
                                <i class="el-icon-video-play"></i> 当前视频
                                <el-button type="text" size="mini" style="margin-left:10px;" @click="showUpload = true">
                                    替换视频
                                </el-button>
                            </div>
                        </div>

                        <!-- COS上传组件 -->
                        <div v-if="showUpload">
                            <cosupload ref="cosupload" upload_class="tutorial" :limit_url="1" :mb="10"
                                :uploadkey="uploadkey" @upload-success="handleUploadSuccess" />
                        </div>

                        <!-- 刚上传的视频预览 -->
                        <div v-if="newVideoUrl" style="margin-top:10px;">
                            <video :src="newVideoUrl" controls
                                style="width:100%;max-height:300px;border-radius:8px;background:#000;"></video>
                            <div style="margin-top:5px;font-size:13px;color:#67c23a;">
                                <i class="el-icon-success"></i> 新视频已上传
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="教程图片" v-if="mode === 'images'">
                        <div v-if="form.images.length > 0"
                            style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px;">
                            <div v-for="(img, idx) in form.images" :key="idx"
                                draggable="true"
                                @dragstart="dragStart(idx, $event)"
                                @dragover.prevent="dragOver(idx, $event)"
                                @drop="drop(idx, $event)"
                                @dragend="dragEnd"
                                :style="{position:'relative',border:dragIndex===idx?'2px dashed #409eff':'2px solid transparent',borderRadius:'8px',padding:'1px',cursor:'grab',transition:'border-color 0.2s'}"
                                @mouseenter="$event.currentTarget.style.borderColor='#409eff'"
                                @mouseleave="dragIndex !== idx && ($event.currentTarget.style.borderColor='transparent')">
                                <el-image :src="img" fit="cover"
                                    style="width:100px;height:70px;border-radius:6px;display:block;pointer-events:none;">
                                </el-image>
                                <i class="el-icon-delete" @click="deleteImage(idx)"
                                    style="position:absolute;top:-8px;right:-8px;font-size:16px;color:#fff;background:#f56c6c;border-radius:50%;padding:3px;cursor:pointer;"></i>
                            </div>
                        </div>
                        <cosupload ref="cosupload_images" :image_mode="true" upload_class="tutorial" :limit_url="20"
                            :mb="5" :uploadkey="uploadkey" @upload-success="handleImagesSuccess" />

                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="save" :loading="saving">
                            {{ saving ? '保存中...' : '保存' }}
                        </el-button>
                        <el-button @click="$router.push('/user/upload_tutorial')">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
import cosupload from '@/components/common/cosupload.vue'
export default {
    name: 'TutorialEdit',
    components: { cosupload },
    data() {
        return {
            mode: 'video',
            dragIndex: null,
            form: { title: '', tags: [], description: '', status: 1, images: [] },
            tutorialTypes: [],
            typesLoaded: false,
            coverUrl: '',
            localVideoUrl: '',
            newVideoUrl: '',
            uploadkey: '',
            showUpload: false,
            saving: false
        }
    },
    computed: {
        isEdit() {
            return !!this.$route.query.id
        },
        tagOptions() {
            return this.tutorialTypes.filter(function (t) { return t !== '全部' })
        }
    },
    methods: {
        switchMode(val) {
            this.mode = val
        },
        loadTypes() {
            if (this.typesLoaded) return
            this.$ajax.get('qhy/app/get_tutorial_types').then(res => {
                if (res.data.status == 200) {
                    this.tutorialTypes = res.data.data || []
                    this.typesLoaded = true
                }
            })
        },
        handleUploadSuccess(data) {
            this.newVideoUrl = data.url
        },
        handleCoverSuccess(data) {
            this.coverUrl = data.url
        },
        handleImagesSuccess(data) {
            if (data.url && this.form.images.indexOf(data.url) === -1) {
                this.form.images.push(data.url)
            }
        },
        deleteImage(idx) {
            this.form.images.splice(idx, 1)
        },
        dragStart(idx, e) {
            this.dragIndex = idx
            e.dataTransfer.effectAllowed = 'move'
        },
        dragOver(idx, e) {
            if (this.dragIndex === null || this.dragIndex === idx) return
            e.dataTransfer.dropEffect = 'move'
        },
        drop(idx, e) {
            if (this.dragIndex === null || this.dragIndex === idx) return
            var item = this.form.images.splice(this.dragIndex, 1)[0]
            this.form.images.splice(idx, 0, item)
            this.dragIndex = null
        },
        dragEnd() {
            this.dragIndex = null
        },
        save() {
            if (!this.form.title.trim()) {
                this.$message.warning('请输入教程标题')
                return
            }

            var videoUrl = ''
            if (this.mode === 'video') {
                videoUrl = this.newVideoUrl || this.localVideoUrl
                if (!videoUrl && this.$refs.cosupload) {
                    var urls = this.$refs.cosupload.get_urls(1)
                    if (urls.status != 100 && urls.length > 0) {
                        videoUrl = urls[0].url
                    }
                }
                if (!videoUrl) {
                    this.$message.warning('请先上传视频')
                    return
                }
            }

            // 保存时清空另一方的数据
            if (this.mode === 'video') {
                this.form.images = []
            } else {
                this.localVideoUrl = ''
                this.newVideoUrl = ''
            }

            this.saving = true
            var data = {
                title: this.form.title,
                tags: this.form.tags,
                status: this.form.status,
                description: this.form.description,
                cover: this.coverUrl
            }
            if (this.mode === 'video') {
                data.video = videoUrl
            } else {
                // 收集图片链接
                var images = [].concat(this.form.images)
                if (this.$refs.cosupload_images) {
                    var imgUrls = this.$refs.cosupload_images.get_urls(1)
                    if (imgUrls.status != 100) {
                        for (var i = 0; i < imgUrls.length; i++) {
                            if (images.indexOf(imgUrls[i].url) === -1) {
                                images.push(imgUrls[i].url)
                            }
                        }
                    }
                }
                data.images = images
            }
            if (this.isEdit) {
                data.id = this.$route.query.id
            }

            this.$ajax.post('qhy/app/tutorial_update', data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(res => {
                if (res.data.status == 200) {
                    this.$message.success('保存成功')
                    var newId = res.data.data && res.data.data.id
                    if (newId) {
                        this.$router.replace('/user/tutorial_edit?id=' + newId)
                    } else {
                        this.$router.push('/user/upload_tutorial')
                    }
                } else {
                    this.$message.error(res.data.msg || '保存失败')
                }
                this.saving = false
            }).catch(() => {
                this.$message.error('保存失败，请稍后重试')
                this.saving = false
            })
        },
        loadDetail() {
            this.$ajax.get('qhy/app/tutorial_info?id=' + this.$route.query.id).then(res => {
                if (res.data.status == 200) {
                    var d = res.data.data || {}
                    this.form.title = d.title || ''
                    this.form.tags = d.tags ? (typeof d.tags === 'string' ? JSON.parse(d.tags) : d.tags) : []
                    this.form.status = d.status != null ? d.status : 1
                    this.form.description = d.description || ''
                    this.localVideoUrl = d.video || ''
                    this.coverUrl = d.cover || ''
                    var imgs = d.images ? (typeof d.images === 'string' ? JSON.parse(d.images) : d.images) : []
                    this.form.images = imgs
                    // 根据已有数据设置内容类型
                    if (imgs.length > 0) {
                        this.mode = 'images'
                        this.showUpload = false
                    } else {
                        this.mode = 'video'
                        this.showUpload = !this.localVideoUrl
                    }
                } else {
                    this.$message.error(res.data.msg || '加载失败')
                }
            }).catch(() => {
                this.$message.error('加载失败')
            })
        }
    },
    created() {
        if (this.isEdit) {
            this.loadDetail()
        } else {
            this.showUpload = true
        }
    }
}
</script>

<style scoped>
.tutorial-edit-container {
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 100px);
    background-color: #f6f7f8;
}

.tutorial-edit-content {
    max-width: 800px;
    width: 100%;
    margin-top: 10px;
}

.header-section {
    margin-bottom: 20px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/User/TutorialEdit.vue


// WEBPACK FOOTER //
// src/components/User/TutorialEdit.vue